<template>
  <span class="frcp-spinner" :style="style" />
</template>

<script>
  export default {
    props: {
      diameter: {
        type: Number,
        default: 20
      }
    },
    computed: {
      style() {
        return {
          width: this.diameter + 'px',
          height: this.diameter + 'px',
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@CustomerPage/css/_mixins.scss';

  .frcp-spinner {
    @include middle-align-child;
    z-index: 10;

    &:after {
      @include css-loading-spinner;
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
    }
  }
</style>
